import { render, staticRenderFns } from "./personInfo.vue?vue&type=template&id=549c1d43&"
import script from "./personInfo.vue?vue&type=script&lang=js&"
export * from "./personInfo.vue?vue&type=script&lang=js&"
import style0 from "./personInfo.vue?vue&type=style&index=0&id=549c1d43&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/www/game/xcp-vue-xcll/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('549c1d43')) {
      api.createRecord('549c1d43', component.options)
    } else {
      api.reload('549c1d43', component.options)
    }
    module.hot.accept("./personInfo.vue?vue&type=template&id=549c1d43&", function () {
      api.rerender('549c1d43', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/view/dashboard/personInfo/personInfo.vue"
export default component.exports